import axios from 'axios';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { CommonState, error, isFetching } from '@pec/aion-ui-core/slices/common';
import { enqueueRequestErrorSnackbar } from '@pec/aion-ui-core/actions/enqueueSnackbar';

const name = 'onlineTrainingSSO';

type Params = {
  userId: string;
  organizationId: string;
  afterSuccess(url: string): void;
};

export const fetchOnlineTrainingSSOUrl = createAsyncThunk(
  `${name}/fetch`,
  async ({ userId, organizationId, afterSuccess }: Params, { dispatch }) => {
    try {
      const { data } = await axios.post<{ url: string }>(`/api/v1/products/addons/humanfocus/sso`, {
        userId,
        organizationId
      });

      afterSuccess(data.url);
      return data.url;
    } catch (error) {
      dispatch(enqueueRequestErrorSnackbar());
      throw error;
    }
  }
);

export type State = CommonState & {
  SSOUrl: string;
};

const initialState: State = {
  SSOUrl: '',
  isFetching: false,
  error: null
};

const onlineTrainingSSOUrl = createSlice({
  name,
  initialState,
  reducers: {
    changeIsFetchingSSOUrl(state) {
      state.isFetching = !state.isFetching;
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchOnlineTrainingSSOUrl.pending, isFetching)
      .addCase(fetchOnlineTrainingSSOUrl.fulfilled, (state, action) => {
        state.SSOUrl = action.payload;
        state.isFetching = false;
      })
      .addCase(fetchOnlineTrainingSSOUrl.rejected, error);
  }
});

export const {
  reducer: onlineTrainingSSOReducer,
  actions: { changeIsFetchingSSOUrl }
} = onlineTrainingSSOUrl;
